/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_CtaInputs */

const en_visa_eb3_cta = /** @type {(inputs: Visa_Eb3_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore your EB-3 pathway`)
};

const pt_visa_eb3_cta = /** @type {(inputs: Visa_Eb3_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore seu caminho EB-3`)
};

const es_visa_eb3_cta = /** @type {(inputs: Visa_Eb3_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore su camino EB-3`)
};

/**
* | output |
* | --- |
* | "Explore your EB-3 pathway" |
*
* @param {Visa_Eb3_CtaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_cta = /** @type {((inputs?: Visa_Eb3_CtaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_CtaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_cta(inputs)
	if (locale === "es") return es_visa_eb3_cta(inputs)
	return en_visa_eb3_cta(inputs)
});